"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledDialogFooter = void 0;
var _DialogFooter = require("./DialogFooter");
// TODO: in v9, move styled() from DialogFooter.jsx to here
var StyledDialogFooter = _DialogFooter.DialogFooter;
exports.StyledDialogFooter = StyledDialogFooter;